import { Route, Routes as ReactRouterRoutes } from "react-router-dom";
import Home from "./pages/Home/Home.js";
import About from "./pages/About/About.js";
import PostSubmission from "./pages/PostSubmission/PostSubmission.js";

const Routes = () => (
  <ReactRouterRoutes>
    <Route exact path="/" element={<Home />} />
    <Route exact path="/about" element={<About />} />
    <Route exact path="/post-submission" element={<PostSubmission />} />
  </ReactRouterRoutes>
);

export default Routes;
